// this reducer stores the corporate event info
// it also stores the groups
// firebase data is stored here: https://console.firebase.google.com/u/0/project/barhuntv2/database/barhuntv2/data/customEvents

import {createSlice} from '@reduxjs/toolkit';
import moment from 'moment';
import {mmkvStorage} from '../../Utils/mmkvStorage';
import {logCustomAnalyticsEvent} from '../../Utils/fireUtils';

const initialState = {
  info: null,
  eventId: null,
  groups: null, // the corporate groups, found by querying on eventId
  photos: [], // setting corproate photos
  hostMaximized: false,
};

const eventSlice = createSlice({
  name: 'event',
  initialState,
  reducers: {
    updateEventInfo(state, {payload: info = null}) {
      state.info = info;
    },
    setEventId(state, {payload: eventId = null}) {
      const newLastActive = moment().format('YYYY-MM-DDTHH:mm:ss.sssZ');
      mmkvStorage.set('eventLastActive', newLastActive);
      if (eventId) {
        logCustomAnalyticsEvent('join_custom_event', {
          eventId,
        });
      }
      state.eventId = eventId;
    },
    updateEventGroups(state, {payload: groups = null}) {
      state.groups = groups;
    },
    setEventPhotos(state, {payload: photos = null}) {
      state.photos = photos;
    },
    setHostMaximized(state, {payload: hostMaximized = null}) {
      console.log('setHostMaximized', {hostMaximized});
      state.hostMaximized = hostMaximized;
    },
  },
});

export const {
  updateEventInfo,
  updateEventGroups,
  setEventPhotos,
  setEventId,
  setHostMaximized,
} = eventSlice.actions;

export default eventSlice.reducer;
